import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WatchService} from "../../services/watch.service";
import * as _ from "underscore";


@Component({
  selector: 'nv-list',
  templateUrl: './nv-list.component.html',
  styles: []
})
export class NvListComponent implements OnInit {
  private selectedItem: any = null;
  private _items: any[];

  @Input() set items(v: any[]) {
    this._items = v;
    this.onSelectClick(null);
  }

  @Input() getLabelCallback: (item:any) => string;
  @Output() onItemSelected = new EventEmitter();

  get items() { return this._items; }


  constructor(private watchService: WatchService) { }


  ngOnInit() {
  }


  isSelected(item: any) {
    return this.selectedItem === item;
  }


  onSelectClick(item: any) {
    this.selectedItem = item;
    this.onItemSelected.emit(item);
  }


  onRemoved(item: any) {
    if (this.selectedItem === item) {
      this.onSelectClick(null);
    }
    this.watchService.notify();
  }


  getLabel(item: any) {
    if (_.isFunction(this.getLabelCallback)) {
      return this.getLabelCallback(item);
    }

    return `index: ${this.items.indexOf(item)}`;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-list/nv-list.component.ts